import React, { Component } from 'react'

class AddEquipment extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: true,
      defaultName: '',
      defaultBody: '',
      name: '',
      body: ''
    }
  }

  _handleCancelClick () {
    this.setState({
      edit: false,
      name: this.state.defaultName,
      body: this.state.defaultBody
    })
    this.props.cancel()
  }

  _handleSaveClick () {
    console.log('saving data...')
    const { name, body } = this.state
    const data = {
      name,
      body
    }
    this.props.saveData(data)
    this.setState({ edit: false })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _renderFacilityName () {
    return <textarea rows="1" type="text" value={this.state.name} onChange={this._handleUpdateContent.bind(this, 'name')}></textarea>
  }
  _renderFacilityBody () {
    return <textarea rows="1" type="text" value={this.state.body} onChange={this._handleUpdateContent.bind(this, 'body')}></textarea>
  }

  render () {
    return (
      <article className="facility">
        <div className="facility_inner admin_inner flex column">
          <div className="contents flex top_label">
            <div className="facility_label label">公共施設名</div>
            { this._renderFacilityName()}
          </div>
          <div className="contents flex bottom_label">
            <div className="facility_label label">電話番号</div>
            { this._renderFacilityBody()}
          </div>
        </div>
        <div className="btn_group flex">
          <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>
          <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
        </div>
      </article>
    )
  }
}

export default AddEquipment



// WEBPACK FOOTER //
// ./src/components/Properties/PublicFacilities/AddPublicFacility.js